/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';

export class lodgemembershipsummary extends IceEntity {
  date_of_summary: any = NaN;
  charter_number: string = "";
  starting_date: any = NaN;
  ending_date: any = NaN;
  functioning_status: string = "";
  number_of_members: number = 0;
  active_members: number = 0;
  meeting_location: string = "";
  activities: string = "";
  other_activities: string = "";
  transfer_name1: string = "";
  transfer_to_charter1: string = "";
  transfer_effective_date1: any = NaN;
  transfer_name2: string = "";
  transfer_to_charter2: string = "";
  transfer_effective_date2: any = NaN;
  remit_period: string = "";
  remitted_amount: number = 0.0;
  suggestions: string = "";
  organization_name: string = "";
  street1: string = "";
  street2: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  province: string = "";
  country_id: string = "";

  public gettablename(): string {
    return "LODGE_MEMBERSHIP_SUMMARY";
  }
}
